<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Feriado {{ form.descripcion }}</h3>
      </div>
      <div class="layout__controls">
        <button v-show="(permiteEditarFeriado || permiteEliminarFeriado)" @click="$modal.show('feriados')" class="btn-info btn--bigger"><i class="fa fa-search"></i> <span>Buscar</span></button>
        <modal name="feriados" height="auto" width="60%" scrollable>
          <lista-feriados @selected="selectedFeriado" :editButton="false" :createButton="false" :deleteButton="false"></lista-feriados>
        </modal>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <H5>Información del feriado</H5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-6">
                  <div class="form-field">
                    <input-field v-model="form.descripcion" id="nombre" placeholder="Escriba una descripción...">
                        <span>Descripción</span>
                        <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
                            {{ errores.descripcion[0] }}
                        </span>
                    </input-field>
                  </div>
              </div>
              <div class="col-xs-12 col-md-6">
                  <div class="form-field">
                    <div class="datepicker-field">
                        <date-picker v-model="form.fecha" type="date" format="dd-MM-yyyy" id="fecha" lang="es"></date-picker>
                        <label for="fecha">Fecha</label>
                        <span v-if="errores.fecha" class="helper-text text-danger" slot="helper">
                            <strong>{{ errores.fecha[0] }}</strong>
                        </span>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button v-show="(permiteCrearFeriado && estado === 'N') || (permiteEditarFeriado && estado !== 'N')" @click="guardar" class="btn-success" type="button"><i class="fa fa-save"></i><span>Guardar</span></button>
            <button v-show="permiteCrearFeriado" @click="crearNueva" class="btn-light btn--text" type="button"><i class="fa fa-plus"></i><span>Nueva</span></button>
            <button v-show="estado === 'A' && permiteEliminarFeriado" @click="eliminar" type="button" class="btn-danger btn--text"><i class="fa fa-ban"></i> <span>Eliminar</span></button>
            <button v-show="estado === 'I' && permiteEliminarFeriado" @click="eliminar" type="button" class="btn-dark btn--text"><i class="fa fa-power-off"></i><span>Re-activar</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props : {
        permiteCrearFeriado : {
            type : Boolean,
            default : true,
            required : true
        },
        permiteEditarFeriado : {
            type : Boolean,
            default : true,
            required : true
        },
        permiteEliminarFeriado : {
            type : Boolean,
            default : true,
            required : true
        }
    },
    data : function () {
        return {
            form : {
                descripcion : '',
                _method : undefined,
                fecha : moment(new Date()).format('YYYY-MM-DD')
            },
            estado : 'N',
            errores : {
                descripcion : undefined,
                fecha : undefined
            },
            id : '',
            url : url
        };
    },
    methods : {
        crearNueva : function () {
            let that = this;
            swal({
                title: '¿Desea crear un nuevo feriado?',
                text: "El formulario será reiniciado.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText : 'Crear nuevo',
                cancelButtonText : 'Cancelar'
                }).then((result) => {
                    if (result.value)
                    {
                        that.limpiarFormulario();
                        that.limpiarErrores();
                        that.estado = 'N';
                    }
            });
        },
        limpiarFormulario : function () {
            this.form = {
                descripcion : '',
                _method : undefined,
                fecha : moment(new Date()).format('YYYY-MM-DD')
            };
        },
        limpiarErrores : function () {
            this.errores = {
                descripcion : undefined,
                fecha : undefined
            };
        },
        guardar : function () {
            this.limpiarErrores();
            let that = this;
            let urlRequest = url + '/feriados';
            if (this.estado !== 'N')
            {
                this.form._method = 'PUT';
                urlRequest += '/' + this.id;
            }
            else 
                this.form._method = undefined;
            axios.post(urlRequest, this.form).then(function (response) {
                that.estado = response.data.estado;
                that.id = response.data.id;
                swal('El feriado fue almacenado exitósamente.', 'Realizado', 'success');
            }).catch(function (error) {
                if (error !== null && error !== undefined) {
                    let response = error.response;
                    if (response !== null && response !== undefined) {
                        let status = response.status;
                        if (status === 422) {
                            that.errores = response.data.errors;
                            swal('Hay errores en el formulario.', 'Aviso', 'warning');
                        }
                        else 
                            swal('Hubo un error al momento de guardar el formulario, intente nuevamente.', 'Error', 'error');
                    }
                }
            });
        },
        eliminar : function () {
            let that = this;
            swal({
                title: '¿Desea ' + (this.estado === 'A'?'eliminar':'re-activar') + ' este feriado?',
                text: "El feriado será " + (this.estado === 'A'?'eliminado':'re-activado') + ".",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText : (this.estado === 'A'?'Eliminar':'Re-activar'),
                cancelButtonText : 'Cancelar'
                }).then((result) => {
                    if (result.value)
                    {
                        axios.post(that.url + '/feriados/' + that.id, {
                            _method : 'DELETE'
                        }).then(function (response) {
                            that.estado = response.data.estado;
                            swal('El feriado ha sido ' + (that.estado === 'I'?'eliminado':'re-activado') + '.', 'Realizado', 'success');
                        });
                    }
            });
        },
        selectedFeriado : function (feriado) {
            this.form.descripcion = feriado.descripcion;
            this.form.fecha = moment(new Date(feriado.fecha)).format('YYYY-MM-DD');
            this.estado = feriado.estado;
            this.id = feriado.id;
            this.$modal.hide('feriados');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/feriados/Feriado.vue